{
    "circlePoint": {
        "geometryType": "point",
        "renderer": {
            "type": "simple",
            "symbol": {
                "type": "esriSMS",
                "style": "esriSMSCircle",
                "color": [67, 100, 255, 200],
                "size": 7,
                "outline": {
                    "color": [0, 0, 0, 255],
                    "width": 1
                }
            }
        }
    },
    "solidLine": {
        "geometryType": "polyline",
        "renderer": {
            "type": "simple",
            "symbol": {
                "type": "esriSLS",
                "style": "esriSLSSolid",
                "color": [90, 90, 90, 200],
                "width": 2
            }
        }
    },
    "outlinedPoly": {
        "geometryType": "polygon",
        "renderer": {
            "type": "simple",
            "symbol": {
                "type": "esriSFS",
                "style": "esriSFSSolid",
                "color": [76, 76, 125, 200],
                "outline": {
                    "type": "esriSLS",
                    "style": "esriSLSSolid",
                    "color": [110, 110, 110, 255],
                    "width": 1
                }
            }
        }
    },
    "boundingBoxPoly": {
        "geometryType": "polygon",
        "renderer": {
            "type": "simple",
            "symbol": {
                "type": "esriSFS",
                "style": "esriSFSSolid",
                "color": [255, 0, 0, 64],
                "outline": {
                    "type": "esriSLS",
                    "style": "esriSLSSolid",
                    "color": [240, 128, 128, 255],
                    "width": 1
                }
            }
        }
    }
}
